export default function openNewTab(href: string) {
  Object.assign(document.createElement('a'), {
    target: '_blank',
    href,
  }).click()
}
